/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Meta_Ogdescription1Inputs */

const ja_careers_meta_ogdescription1 = /** @type {(inputs: Careers_Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲーム・eスポーツ業界の未来をともにつくる仲間を募集しています。ゲームマーケティング、クリエイティブ制作、イベント運営、ライブ配信、デジタル開発、ビジネス企画など、幅広い職種で新しい挑戦を歓迎します。`)
};

const en_careers_meta_ogdescription1 = /** @type {(inputs: Careers_Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join PLAYBRAIN and help shape the future of gaming and esports. Explore career opportunities in game marketing, creative production, event management, livestream production, digital development, and business strategy.`)
};

/**
* | output |
* | --- |
* | "Join PLAYBRAIN and help shape the future of gaming and esports. Explore career opportunities in game marketing, creative production, event management, livest..." |
*
* @param {Careers_Meta_Ogdescription1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_meta_ogdescription1 = /** @type {((inputs?: Careers_Meta_Ogdescription1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Meta_Ogdescription1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_meta_ogdescription1(inputs)
	return en_careers_meta_ogdescription1(inputs)
});
export { careers_meta_ogdescription1 as "careers_meta_ogDescription" }